module.exports = __webpack_public_path__ + "static/media/open-ai-logo.642822f7.svg";